(() => {
  'use strict';
  if (typeof window.HexxedWishlist?.getItems === 'function') return;
    const KEY = 'hexxed-wishlist-v2';
  const LEGACY = ['hexxed-wishlist-v1', 'deals-wishlist'];
  const selector = '[data-hx-wishlist]';
  let items = [], opener, previousOverflow = '', rendering = 0, hydration;
  const read = key => { try { const x = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(x) ? x : []; } catch (_) { return []; } };
  const idOf = value => String(typeof value === 'object' && value ? value.id : value || '');
  const validId = id => /^\d+$/.test(id);
  function load() {
    const merged = new Map();
    [...read(KEY), ...LEGACY.flatMap(read)].forEach(value => {
      const id = idOf(value);
      if (validId(id) && !merged.has(id)) merged.set(id, typeof value === 'object' ? {...value, id} : {id});
    });
    items = [...merged.values()];
  }
  function drawer() { return document.querySelector('[data-hx-wishlist-drawer]'); }
  function say(text) { const live = document.querySelector('[data-hx-wishlist-live]'); if (live) { live.textContent = ''; requestAnimationFrame(() => { live.textContent = text; }); } }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(items)); LEGACY.forEach(key => localStorage.setItem(key, JSON.stringify(items.map(x => x.id)))); return true; }
    catch (_) { say(drawer()?.dataset.storageError || 'Your browser could not save your wishlist.'); return false; }
  }
  function data(button) {
    const d = button.dataset;
    return {id:String(d.hxWishlistId || ''), handle:d.hxWishlistHandle, title:d.hxWishlistTitle, url:d.hxWishlistUrl, image:d.hxWishlistImage, price:d.hxWishlistPrice};
  }
  function sync() {
    let enriched = false;
    document.querySelectorAll(selector).forEach(button => {
      const product = data(button), item = items.find(x => x.id === product.id), active = !!item;
      if (item && product.handle && (!item.handle || !item.title)) { Object.assign(item, product); enriched = true; }
      const pressed = String(active);
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      button.classList.toggle('is-active', active);
      if (!button.querySelector('svg') && /^[♡♥]$/.test(button.textContent.trim())) button.textContent = active ? '♥' : '♡';
    });
    document.querySelectorAll('[data-hx-wishlist-count]').forEach(el => { const text = String(items.length); if(el.textContent !== text) el.textContent = text; el.hidden = !items.length; });
    if (enriched) save();
  }
  function toggle(product) {
    if (!validId(product.id)) return;
    const active = items.some(x => x.id === product.id);
    items = active ? items.filter(x => x.id !== product.id) : [...items, product];
    const persisted = save(); sync();
    if (persisted) say(active ? drawer()?.dataset.removed || 'Removed from wishlist' : drawer()?.dataset.added || 'Added to wishlist');
    document.dispatchEvent(new CustomEvent('hexxed:wishlist-change', {detail:{count:items.length}}));
    if (drawer()?.open) render();
  }
  function safeUrl(value) {
    try { const u = new URL(value, location.origin); u.pathname = u.pathname.replace(/\/collections\/[^/]+\/products\//, '/products/'); return u.origin === location.origin && /^\/([a-z]{2}(-[a-z]{2})?\/)?products\//i.test(u.pathname) ? u.href : null; } catch (_) { return null; }
    }
  function safeImage(value) {
    if (!value) return null;
    try { const u = new URL(value, location.origin); return ['https:','http:'].includes(u.protocol) && (u.origin === location.origin || u.hostname === 'cdn.shopify.com') ? u.href : null; } catch (_) {return null;}
  }
  function element(tag, className, text) { const el = document.createElement(tag); if(className)el.className=className; if(text != null)el.textContent=text; return el; }
  async function hydrate() {
    if (!items.some(x => !x.handle)) return;
    if (hydration) return hydration;
    hydration = (async () => {
      const root = drawer()?.dataset.root || '/';
      for (let page=1; page<=8 && items.some(x=>!x.handle); page++) {
        const response = await fetch(`${root}products.json?limit=250&page=${page}`, {credentials:'same-origin'});
        if (!response.ok) throw new Error('catalog');
        const result = await response.json(); const products = result.products || [];
        products.forEach(product => { const item = items.find(x=>x.id===String(product.id)); if(item && !item.handle) Object.assign(item,{handle:product.handle,title:product.title,url:`${root}products/${product.handle}`,image:product.images?.[0]?.src || ''}); });
        if (products.length<250) break;
      }
      save();
    })();
    try { await hydration; } finally { hydration = null; }
  }
  async function render() {
    const panel = drawer(); if (!panel) return;
    const version = ++rendering, list = panel.querySelector('[data-hx-wishlist-list]'), empty = panel.querySelector('[data-hx-wishlist-empty]'), status = panel.querySelector('[data-hx-wishlist-status]');
    list.replaceChildren(); empty.hidden = !!items.length;
    status.hidden = !items.length; status.textContent = panel.dataset.loading;
    if (!items.length) return;
    try { await hydrate(); } catch (_) { /* Keep saved IDs available for removal if catalog is offline. */ }
    const snapshot = items.map(x=>({...x}));
    const results = await Promise.all(snapshot.map(async item => {
      const url = safeUrl(item.url);
      if (!url) return item;
      try { const r = await fetch(`${new URL(url).pathname}.js`,{credentials:'same-origin'}); if(!r.ok) return {...item, unavailable:true}; const product=await r.json(); return {...item,title:product.title,image:product.featured_image || item.image,price:formatPrice(product.price),unavailable:false}; }
      catch (_) {return item;}
    }));
    if (version !== rendering || !panel.open) return;
    status.hidden=true;
    results.forEach(item => {
      const row=element('article','hx-wishlist-drawer__item');
      const image=safeImage(item.image), url=safeUrl(item.url);
      if(image){const img=element('img','hx-wishlist-drawer__image');img.src=image;img.alt=item.title||'';img.loading='lazy';img.width=88;img.height=88;row.append(img);}else{row.append(element('div','hx-wishlist-drawer__image'));}
      const body=element('div'), title=element(url && !item.unavailable?'a':'p','hx-wishlist-drawer__title',item.title||panel.dataset.unavailable);
      if(url && !item.unavailable)title.href=url;
      body.append(title);
      if(item.price)body.append(element('p','hx-wishlist-drawer__price',item.price));
      const actions=element('div','hx-wishlist-drawer__actions');
      if(url && !item.unavailable){const view=element('a','hx-wishlist-drawer__view',panel.dataset.view);view.href=url;actions.append(view);}
      const remove=element('button','hx-wishlist-drawer__remove',panel.dataset.remove);remove.type='button';remove.setAttribute('aria-label',`${panel.dataset.remove}: ${item.title||item.id}`);remove.addEventListener('click',()=>{toggle(item);panel.querySelector('[data-hx-wishlist-close]')?.focus();});actions.append(remove);body.append(actions);row.append(body);list.append(row);
    });
  }
  function formatPrice(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:window.Shopify?.currency?.active||'INR'}).format(cents/100); } catch (_) {return String(cents/100);}
  }
  function open(button) {
    const panel=drawer();if(!panel || panel.open)return;
    opener=button;previousOverflow=document.documentElement.style.overflow;
    panel.showModal();document.documentElement.style.overflow='hidden';
    document.querySelectorAll('[data-hx-wishlist-open]').forEach(b=>b.setAttribute('aria-expanded','true'));
    render();panel.querySelector('[data-hx-wishlist-close]')?.focus();
  }
  function close() { const panel=drawer();if(panel?.open)panel.close();document.documentElement.style.overflow=previousOverflow;document.querySelectorAll('[data-hx-wishlist-open]').forEach(b=>b.setAttribute('aria-expanded','false'));if(opener?.isConnected)opener.focus(); }
  document.addEventListener('click',event=>{
    const heart=event.target.closest(selector);
    if(heart){event.preventDefault();event.stopImmediatePropagation();toggle(data(heart));return;}
    const trigger=event.target.closest('[data-hx-wishlist-open]');if(trigger){event.preventDefault();open(trigger);return;}
    if(event.target.closest('[data-hx-wishlist-close]'))close();
    if(event.target===drawer()){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}
  },true);
  document.addEventListener('cancel',event=>{if(event.target===drawer()){event.preventDefault();close();}},true);
  window.addEventListener('storage',event=>{if(event.key===KEY || LEGACY.includes(event.key)){load();sync();if(drawer()?.open)render();}});
  document.addEventListener('shopify:section:load',()=>{sync();});
  load();sync();save();
  let scheduled=false;
  new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;sync();});}).observe(document.body,{childList:true,subtree:true});
  window.HexxedWishlist={getItems:()=>items.map(x=>({...x})),toggle,open,close};
})();
